#import "../../../../common/components/Modules/TransactionEdit/graphql/InvoiceFragment.graphql"

mutation InvoiceSigningCreateApply($input: InvoiceSigningCreateApplyInput!) {
  invoiceSigningCreateApply(input: $input) {
    invoice {
      ...InvoiceFragment
    }
  }
}
